import { Modal } from 'components/ProfileUIComponents';
import ExitContainer from './ExitContainer';

interface IExitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  imageSrc?: string;
  title?: string;
  description?: string;
  cancelActionText?: string;
  confirmActionText?: string;
  icon?: any;
}
const ExitModal = (props: IExitModalProps) => {
  const {
    isOpen,
    onClose,
    onCancel,
    onConfirm,
    imageSrc,
    title,
    description,
    cancelActionText,
    confirmActionText,
    icon
  } = props;

  return (
    <Modal isOpen={isOpen} onDismiss={onClose}>
      <ExitContainer
        onCancel={onCancel}
        onConfirm={onConfirm}
        showExitContainer={true}
        imageSrc={imageSrc}
        title={title}
        description={description}
        cancelActionText={cancelActionText}
        confirmActionText={confirmActionText}
        icon={icon}
      />
    </Modal>
  );
};
export default ExitModal;
